import {
  all,
  call,
  delay,
  fork,
  select,
  takeEvery,
  takeLatest,
} from 'redux-saga/effects';
import { browserHistory } from 'react-router';
import {
  doneDataById,
  doneDeleteRecord,
  doneListTable,
  doneSaveRecord,
  showErrorDataById,
  showErrorDeleteRecord,
  showErrorListTable,
  showErrorSaveRecord,
  showProgressDataById,
  showProgressDeleteRecord,
  showProgressListTable,
  showProgressSaveRecord,
} from '../sagasCommon';
import { getDocs } from '../../services/apiCommon';

import { ITEM_GROUP_PRICE } from '../../constants/constant_doc_types';
import * as api from '../../services/item_group_price/api_item_group_price';
import { getLocalDatetime } from '../../utils/local_date';

export default function*(app) {
  try {
    yield all([
      fork(fetchListItemGroupPriceSaga, app),
      fork(getItemGroupPriceByIdSaga, app),
      fork(saveItemGroupPriceSaga, app),
      fork(deleteItemGroupPriceSaga, app),
    ]);
  } catch (e) {
    console.error('@saga_item_group_price: ', e.message || e.stack);
    throw e;
  }
}

function* fetchListItemGroupPriceSaga(app) {
  yield takeLatest(
    'FETCH_LIST_ITEM_GROUP_PRICE',
    callFetchListItemGroupPrice,
    app
  );
}

function* callFetchListItemGroupPrice(app, action) {
  try {
    const { silent, filters } = action;
    yield showProgressListTable(silent);
    const { available_from, available_to } = filters;
    const params = {
      filters: {
        ...filters,
        available_from: getLocalDatetime(available_from),
        available_to: getLocalDatetime(available_to),
      },
      list_type: ITEM_GROUP_PRICE,
    };
    const { data: rows, total: total_rows } = yield call(getDocs, app, params);
    yield call(doneListTable, {
      rows,
      total_rows,
    });
  } catch (e) {
    yield showErrorListTable(e);
  }
}

function* saveItemGroupPriceSaga(app) {
  yield takeEvery('SAVE_ITEM_GROUP_PRICE', callSaveItemGroupPrice, app);
}

function* callSaveItemGroupPrice(app, action) {
  try {
    yield showProgressSaveRecord();
    const { tenant, user } = yield select();
    const { data } = action;
    const params = { tenant, user, data };
    const result = yield call(api.saveItemGroupPrice, app, params);
    const id = result && result.id;
    if (id) {
      yield callGetItemGroupPriceById(app, { id, silent: true });
      browserHistory.push(`/admin/item_group_price/edit/${id}`);
    }
    yield doneSaveRecord(result, 'Item group price was saved');
  } catch (e) {
    yield showErrorSaveRecord(e);
  }
}

function* getItemGroupPriceByIdSaga(app) {
  yield takeEvery(
    'FETCH_ITEM_GROUP_PRICE_BY_ID',
    callGetItemGroupPriceById,
    app
  );
}

function* callGetItemGroupPriceById(app, action) {
  try {
    yield showProgressDataById();
    const { id } = action;
    const params = { id };
    if (id) {
      const doc = yield call(api.fetchItemGroupPriceById, app, params);
      yield doneDataById(doc);
    } else {
      const initialValues = {
        active: true,
      };
      yield doneDataById(initialValues);
    }
  } catch (e) {
    yield showErrorDataById(e);
  }
}

function* deleteItemGroupPriceSaga(app) {
  yield takeEvery('DELETE_ITEM_GROUP_PRICE', callDeleteItemGroupPrice, app);
}

function* callDeleteItemGroupPrice(app, action) {
  const result = yield deleteItemGroupPrice(app, action);
  yield delay(2000);
  if (result) {
    browserHistory.push('/admin/item_group_price');
  }
}

function* deleteItemGroupPrice(app, action) {
  try {
    yield showProgressDeleteRecord();
    const { id } = action;
    let result = null;
    if (id) {
      const { id } = action;
      const params = { id };
      result = yield call(api.deleteItemGroupPrice, app, params);
    }
    yield doneDeleteRecord(id, ITEM_GROUP_PRICE);
    return result;
  } catch (e) {
    yield showErrorDeleteRecord(e);
  }
}
